var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickCallsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_874_11395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.17 13.1472L7.34299 10.2352C6.96115 9.83662 6.71047 9.33071 6.62466 8.78546C6.53885 8.24021 6.62202 7.68176 6.86299 7.18518L7.02299 6.85518C7.26398 6.35854 7.34706 5.79999 7.26107 5.25471C7.17508 4.70942 6.92413 4.20356 6.54199 3.80518L3.03699 0.193182C2.96598 0.119065 2.87794 0.0634213 2.78052 0.0310908C2.6831 -0.00123961 2.57926 -0.00927719 2.47802 0.0076773C2.37679 0.0246318 2.28123 0.0660648 2.19966 0.128372C2.11809 0.190679 2.05298 0.271973 2.00999 0.365182L0.593992 3.28218C-0.489008 5.51418 -0.0640075 8.20918 1.64799 9.97418L9.34199 17.9002C11.206 19.8202 13.964 20.4902 16.465 19.6322L19.561 18.5682C19.6663 18.5307 19.7605 18.4673 19.8348 18.3838C19.9091 18.3003 19.9612 18.1994 19.9862 18.0905C20.0112 17.9816 20.0084 17.8681 19.9779 17.7605C19.9475 17.653 19.8904 17.5548 19.812 17.4752L16.412 13.9722C16.0379 13.5813 15.5474 13.3219 15.0137 13.2327C14.4801 13.1435 13.9319 13.2293 13.451 13.4772L13.131 13.6422C12.65 13.8898 12.1019 13.9754 11.5683 13.8862C11.0348 13.797 10.5443 13.5378 10.17 13.1472Z",
    fill: "#A7ADB7",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_874_11395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickCallsvg);
export default __webpack_public_path__ + "static/media/quick-call.svg.b90fab8662a02e616db5258cdb939c98.svg";
export { ForwardRef as ReactComponent };